import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

type SiteStats = {
  jobs: number;
  companies: number;
  candidates: number;
};

type UseSiteStatsResult = {
  stats: SiteStats;
  loading: boolean;
  error: string | null;
};

export const useSiteStats = (): UseSiteStatsResult => {
  const [stats, setStats] = useState<SiteStats>({
    jobs: 0,
    companies: 0,
    candidates: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data, error: rpcError } = await supabase.rpc("get_site_stats");

        if (rpcError) {
          console.error("Error fetching site stats via RPC:", rpcError);
          setError("Não foi possível carregar as estatísticas do site.");
          setLoading(false);
          return;
        }

        const statsRow = Array.isArray(data) ? data[0] : data;

        if (statsRow) {
          setStats({
            jobs: statsRow.total_jobs ?? 0,
            companies: statsRow.total_companies ?? 0,
            candidates: statsRow.total_candidates ?? 0,
          });
        }
      } catch (err) {
        console.error("Error fetching site stats:", err);
        setError("Não foi possível carregar as estatísticas do site.");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return { stats, loading, error };
};

